"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * In Microsoft Edge, Intl.DateTimeFormat returns invisible characters
 * around the individual numbers.
 */
function sanitiseDateString(string) {
    return string.replace(String.fromCharCode(8206), '');
}
exports.sanitiseDateString = sanitiseDateString;
